/**
 * Kompres gambar di browser (canvas) sebelum upload.
 * Resize max side + JPEG quality, tanpa dependency ekstra.
 */
export const compressImageFile = (
    file,
    {
        maxWidth = 1024,
        maxHeight = 1024,
        quality = 0.82,
        mimeType = 'image/jpeg',
    } = {},
) =>
    new Promise((resolve, reject) => {
        if (!file?.type?.startsWith('image/')) {
            reject(new Error('Bukan file gambar'));
            return;
        }

        const objectUrl = URL.createObjectURL(file);
        const img = new Image();

        img.onload = () => {
            URL.revokeObjectURL(objectUrl);
            let { width, height } = img;

            const scale = Math.min(1, maxWidth / width, maxHeight / height);
            width = Math.round(width * scale);
            height = Math.round(height * scale);

            const canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext('2d');
            if (!ctx) {
                reject(new Error('Canvas tidak tersedia'));
                return;
            }

            ctx.fillStyle = '#ffffff';
            ctx.fillRect(0, 0, width, height);
            ctx.drawImage(img, 0, 0, width, height);

            canvas.toBlob(
                (blob) => {
                    if (!blob) {
                        reject(new Error('Gagal kompres gambar'));
                        return;
                    }
                    const base = String(file.name || 'profile').replace(/\.[^.]+$/, '');
                    const compressed = new File([blob], `${base}.jpg`, {
                        type: mimeType,
                        lastModified: Date.now(),
                    });
                    resolve(compressed);
                },
                mimeType,
                quality,
            );
        };

        img.onerror = () => {
            URL.revokeObjectURL(objectUrl);
            reject(new Error('Gagal membaca gambar'));
        };

        img.src = objectUrl;
    });
